/**
 * @generated SignedSource<<8d8d57f1faf9c7828fd51382bd4858d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type isFilterValueApplied_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly urlLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "isFilterValueApplied_itemSearch";
};
export type isFilterValueApplied_itemSearch$key = {
  readonly " $data"?: isFilterValueApplied_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"isFilterValueApplied_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "isFilterValueApplied_itemSearch"
};

(node as any).hash = "057c56badb8e5252e9573615f5e8d212";

export default node;
